// Lib
import { clamp } from 'lodash';

// Utils
import { getMinScale } from './zoomScaleUtils';

// Constants
import { ZOOM_PROPS } from './zoomConstants';

// Types
import { RectSize } from '../../../common/maths/geometry/rect/rectTypes';

export const ZOOM_DIRECTIONS = {
    UNKNOWN: 'UNKNOWN',
    IN: 'IN',
    OUT: 'OUT',
};

export const getZoomDirection = (ratioChange: number, currentZoomDirection: string): string => {
    if (currentZoomDirection === ZOOM_DIRECTIONS.UNKNOWN && ratioChange < 0.95) {
        return ZOOM_DIRECTIONS.OUT;
    } else if (currentZoomDirection === ZOOM_DIRECTIONS.UNKNOWN && ratioChange > 1.15) {
        return ZOOM_DIRECTIONS.IN;
    }
    return ZOOM_DIRECTIONS.UNKNOWN;
};

/**
 * Determine the next scale to use based on the current zoom state and the change in scale.
 */
// FIXME handle zoom out on iPad
export const getZoomNextScaleOnTouch = (
    canvasViewportClientRect: DOMRect,
    canvasDocumentSize: RectSize,
    nextScale: number,
    initialScale: number,
    zoomDirection: string,
) => {
    const minScale = getMinScale(canvasViewportClientRect, canvasDocumentSize);

    let adjustedNextScale = clamp(nextScale, minScale, ZOOM_PROPS.MAX_SCALE);

    const clampTo100Percent =
        (adjustedNextScale > 1 && initialScale < 1) ||
        (adjustedNextScale < 1 && initialScale > 1) ||
        (initialScale === 1 && zoomDirection === ZOOM_DIRECTIONS.IN && adjustedNextScale < 1) ||
        (initialScale === 1 && zoomDirection === ZOOM_DIRECTIONS.OUT && adjustedNextScale > 1);

    // Force scales beyond 100% or less than 100% to occur in two distinct scales
    if (clampTo100Percent) {
        adjustedNextScale = 1;
    }

    return adjustedNextScale;
};
